import { SweetAlertHelper } from './../../../../core/helpers/sweet-alert-helper.service';
import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { SkillsService } from '../../skills.service';

@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.scss']
})
export class SkillsComponent implements OnInit {

  gridSkills: GridOptions;
  selectedSkill;
  activeAdd = false;

  constructor(private service: SkillsService, private sweetAlertHelper: SweetAlertHelper) {
    this.getGridColumns();
  }

  ngOnInit() {
  }

  setSelected(event) {
    this.selectedSkill = event.data.skillid;
    event.node.setSelected(true);

     this.editSkill();
  }

  /**
   * this open selected skill to edit
   */
  editSkill() {
    this.changeActiveAdd();
  }

  /**
   * this open view to add a new skill
   */
  addNewSkill() {
    this.selectedSkill = 0;
    this.changeActiveAdd();
  }

  /**
   * @name changeActiveAdd
   * @description description
   */
  changeActiveAdd() {
    this.activeAdd = true;
  }

  /**
   * this get all skill data
   */
  private getAllSkills() {
    this.service.getSkills().subscribe(
      data => {
        const filter = this.gridSkills.api.getFilterModel();
        this.gridSkills.api.setRowData(data);
        this.gridSkills.api.setFilterModel(filter);
      }, (error) => this.sweetAlertHelper.captureException(error)
    );
  }

  /**
   * this set the columns to grid
   */
  private getGridColumns() {
    this.gridSkills = <GridOptions>{
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      columnDefs: [
        {
          headerName: 'Skill',
          field: 'description',
          colId: 'desc'
        }
      ],
      onGridReady: () => {
        this.gridSkills.api.sizeColumnsToFit();
        this.getAllSkills();
      }
    }
  }

  /**
   * this execute when skill is saved or updated successfully
   */
  onSuccessSkill() {
    this.changeActiveAdd();
    this.selectedSkill = 0;
    this.getAllSkills();
    this.activeAdd = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/autorouting/components/skills/skills.component.ts